export const getAllSuperAgent = "GET_ALL_SUPER_AGENT";
export const getAllGovernmentShip = "GET_ALL_GOVERNMENT_SHIP";
export const getAllMunicipality = "GET_ALL_MUNICIPALITY";
export const getAllProvince = "GET_ALL_PROVINCE";
export const getAllCompany = "GET_ALL_COMPANY";
export const getAllService = "GET_ALL_SERVICE";
export const getAllStudent = "GET_ALL_STUDENT";
export const getAllDriver = "GET_ALL_DRIVER";
export const getAllParent = "GET_ALL_PARENT";
export const getAllSchool = "GET_ALL_SCHOOL";
export const getAllCity = "GET_ALL_CITY";
export const getAllAbsent = "GET_ALL_ABSENT";
export const getAllLog = "GET_ALL_LOG";
export const getAllFinancialGroup = "GET_ALL_FINANCIAL_GROUP";
export const getInvoices = "GET_INVOICES";
export const getAllTransactions = "GET_TRANSACTIONS";
export const getMicroTransactions = "GET_MICRO_TRANSACTIONS";
export const getAllUser = "GET_ALL_USER";
export const getAllDebts = "GET_ALL_DEBT";
export const getAllTicket = "GET_ALL_TICKET";
export const userInfo = "USER_INFO";
export const getAllAcademicYear = "GET_ALL_ACADEMIC_YEAR";
export const adminDebtFactor = "ADMIN_DEBT_FACTORS";
export const getAllCompanyFactor = "GET_ALL_COMPANY_FACTOR";
export const findPayAdminToDriver = "FIND_PAY_TO_DRIVER";
export const parentTransaction = "PARENT_TRANSACTION";
export const approvedParentTransaction = "APPROVED_PARENT_TRANSACTION";
export const rejectedParentTransaction = "REJECTED_PARENT_TRANSACTION";
export const driverTransaction = "DRIVER_TRANSACTION";
export const onlineDriverTransaction = "ONLINE_DRIVER_TRANSACTION";
export const getDepositPrice4Company = 'GET_DEPOSIT_PRICE_4_COMPANY';
export const findWithdrawalCompany = "FIND_WITHDRAWAL_COMPANIES";
export const companyGetFactorsIsNeedPay2Company = 'COMPANY_GET_FACTORS_IS_NEED_PAY_2_COMPANY';
export const companyGetFinancialReportDrivers = 'COMPANY_GET_FINANCIAL_REPORT_DRIVERS';

export const getWithdrawalAdmin   = 'GET_WITHDRAWAL_ADMIN'  ;
export const getWithdrawalDriver  = 'GET_WITHDRAWAL_DRIVER' ;
export const getWithdrawalCompany = 'GET_WITHDRAWAL_COMPANY';

export const locationGetNeighborhood = 'LOCATION_GET_NEIGHBORHOOD';
export const locationGetProvince     = 'LOCATION_GET_PROVINCE'    ;
export const locationGetCity         = 'LOCATION_GET_CITY'        ;
export const locationGetArea         = 'LOCATION_GET_AREA'        ;
